module.exports = __webpack_public_path__ + "images/emoji/crossed_flags.cca96eadba8cc30d4691.png";